import i18n from 'i18next';

export const generateGenderPayload = (genderValue: string): string => {
  if (!genderValue) return '';
  
  // Direct enum values
  if (['Woman', 'Man', 'Diverse'].includes(genderValue)) {
    return genderValue;
  }
  
  // Translation from translation keys
  const translationMap: Record<string, string> = {
    [i18n.t('woman')]: 'Woman',
    [i18n.t('man')]: 'Man', 
    [i18n.t('diverse')]: 'Diverse'
  };
  
  return translationMap[genderValue] || genderValue;
};

export default generateGenderPayload;
